import pathToRegexp from 'path-to-regexp';
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path, options) {
    if (options === void 0) { options = {}; }
    var cacheKey = "".concat(options.end).concat(options.strict).concat(options.sensitive);
    var pathCache = cache[cacheKey] || (cache[cacheKey] = {});
    if (pathCache[path]) {
        return pathCache[path];
    }
    var keys = [];
    var regexp = pathToRegexp(path, keys, options);
    var result = { regexp: regexp, keys: keys };
    if (cacheCount < cacheLimit) {
        pathCache[path] = result;
        cacheCount++;
    }
    return result;
}
export default function matchPath(pathname, _a) {
    var _b = _a.path, path = _b === void 0 ? [] : _b, _c = _a.exact, exact = _c === void 0 ? false : _c, _d = _a.strict, strict = _d === void 0 ? false : _d, _e = _a.sensitive, sensitive = _e === void 0 ? false : _e;
    var paths = [].concat(path);
    return paths.reduce(function (matched, currentPath) {
        if (matched) {
            return matched;
        }
        var _a = compilePath(currentPath, {
            end: exact,
            strict: strict,
            sensitive: sensitive,
        }), regexp = _a.regexp, keys = _a.keys;
        var match = regexp.exec(pathname);
        if (!match) {
            return null;
        }
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) {
            return null;
        }
        return {
            path: currentPath,
            url: currentPath === '/' && url === '' ? '/' : url,
            isExact: isExact,
            params: keys.reduce(function (memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {}),
        };
    }, null);
}
//# sourceMappingURL=matchPath.js.map